var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10447_211405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8 5.04762C2.8 3.80629 3.80629 2.8 5.04762 2.8H14.9524C16.1937 2.8 17.2 3.80629 17.2 5.04762V14.9524C17.2 16.1937 16.1937 17.2 14.9524 17.2H5.04762C3.80629 17.2 2.8 16.1937 2.8 14.9524V5.04762Z",
    stroke: "currentColor",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7491 14.479L8.79088 9.33708C8.69923 9.09643 8.70694 8.82922 8.8123 8.59424C8.91766 8.35927 9.11205 8.17577 9.35271 8.08412C9.59336 7.99246 9.86057 8.00017 10.0955 8.10553C10.3305 8.21089 10.514 8.40528 10.6057 8.64594L12.3335 13.1829",
    stroke: "currentColor",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2204 12.8829L11.7596 11.673C11.668 11.4324 11.6757 11.1652 11.781 10.9302C11.8864 10.6952 12.0808 10.5117 12.3215 10.4201C12.5621 10.3284 12.8293 10.3361 13.0643 10.4415C13.2993 10.5468 13.4828 10.7412 13.5744 10.9819L14.1504 12.4942",
    stroke: "currentColor",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8065 11.5793C13.7149 11.3386 13.7226 11.0714 13.8279 10.8364C13.9333 10.6015 14.1277 10.418 14.3683 10.3263C14.609 10.2347 14.8762 10.2424 15.1112 10.3477C15.3462 10.4531 15.5296 10.6475 15.6213 10.8881L15.9669 11.7955",
    stroke: "currentColor",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8352 11.4975C15.7435 11.2568 15.7512 10.9896 15.8566 10.7546C15.962 10.5197 16.1564 10.3362 16.397 10.2445C16.6377 10.1529 16.9049 10.1606 17.1399 10.2659C17.3748 10.3713 17.5583 10.5657 17.65 10.8063L20.0095 16.504M14.6966 20.0459C14.0588 19.9624 12.2232 18.8507 11.7014 18.4746L11.5137 18.3383C11.2146 18.1204 10.1125 17.2178 8.20631 15.6303C8.012 15.4684 7.88849 15.2372 7.86205 14.9857C7.83561 14.7342 7.90832 14.4823 8.06473 14.2836C8.23128 14.0718 8.46381 13.9218 8.72539 13.8573C8.98697 13.7929 9.26259 13.8176 9.50847 13.9277L10.7364 14.4783",
    stroke: "currentColor",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45311 7.95509L5.73438 7.63281",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25488 11.1377L5.73438 11.3359",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3389 6.1455L11.6611 5.42677",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4297 7.90625L13.9502 7.70802",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10447_211405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdIcon);
export default __webpack_public_path__ + "static/media/ID-Icon.2edbf055e12d54db9f142d7d74a7fdfa.svg";
export { ForwardRef as ReactComponent };